import { createReducer } from '@ngrx/store';
import { immerOn } from 'ngrx-immer/store';
import {
  setCurrentResponsiveTarget,
  setIsLoadingSearchResults,
  setIsMapVisible,
  setIsMobileFilterOpen,
} from './layout.actions';
import { SessionStorage } from '../utils/session-storage';
import { LayoutState, ResponsiveTarget } from '@immosky/types';

export const initialState: LayoutState = {
  responsiveTarget: ResponsiveTarget.XS,
  isMapVisible: SessionStorage.getIsMapVisible(),
  isMobileFilterOpen: false,
  isLoadingSearchResults: false,
};

export const layoutReducer = createReducer(
  initialState,
  immerOn(setIsMapVisible, (state: LayoutState, { isMapVisible }) => {
    state.isMapVisible = isMapVisible;
    SessionStorage.setIsMapVisible(isMapVisible);
  }),
  immerOn(setIsMobileFilterOpen, (state: LayoutState, { isOpen }) => {
    state.isMobileFilterOpen = isOpen;
  }),
  immerOn(setCurrentResponsiveTarget, (state: LayoutState, { target }) => {
    state.responsiveTarget = target;
  }),
  immerOn(setIsLoadingSearchResults, (state: LayoutState, { isLoading }) => {
    state.isLoadingSearchResults = isLoading;
  })
);
